import {Assignment, ServiceType} from '@features/assignment/types.ts'
import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {ButtonLink} from '@components/commons/button-link'
import {ArrowUpRightIcon} from '@components/ui/icon'
import {ThreeDScanReminderCard} from '@features/assignment/components/three-d-scan-reminder-card'
import {envVars} from '@/envVars.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

export const AssetsReviewDescription: FC<{serviceType: ServiceType; assignment: Assignment}> = ({
    serviceType,
    assignment
}) => {
    const {t} = useTranslation()

    return (
        <div className="flex flex-col gap-6 w-full">
            <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
                <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                    <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                        {t(`assignment:descriptions:assets_review:title:${serviceType}` as TKey)}
                    </h3>
                    <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                        {t(`assignment:descriptions:assets_review:paragraph:${serviceType}` as TKey)}
                    </p>
                </div>
                {assignment.task_category.name == 'Experiences' && assignment.task_media.name == 'video' && (
                    <ButtonLink disabled to="https://airbnb.com" target="_blank" variant="secondary">
                        <span>{t('assignment:open_ikonic')}</span>
                        <ArrowUpRightIcon />
                    </ButtonLink>
                )}
            </div>
            {envVars.VITE_IS_FLOOR_PLAN_ENABLED && assignment.is_3d_scan && (
                <ThreeDScanReminderCard assignment={assignment} />
            )}
        </div>
    )
}
